"use client";

import Link from "next/link";
import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import Container from "../Container";
import Image from "next/image";

const Demo = () => {
    return (
        <section id="demo" className="py-20 bg-black text-white">
            <Container>
                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                        See Peerquik in Action
                    </h2>
                    <div className="mb-12 flex flex-col md:flex-row items-start gap-6 md:gap-8 max-w-3xl mx-auto">
                        <div className="flex-shrink-0">
                            <Image
                                src="/images/eliana-photo.jpeg"
                                alt="Eliana"
                                width={100}
                                height={100}
                                className="w-24 h-24 rounded-full object-cover border-2 border-gray-300 shadow-md"
                            />
                        </div>
                        <div className="text-left">
                            <p className="text-sm mb-3 leading-relaxed">
                                <strong>Hey! I'm Eliana</strong>, Just a dive instructor who learned to code and decided to build apps 🚀<br />
                                I built two SaaS products —
                                <a href="https://scubareputation.com" target="_blank" rel="noopener noreferrer" className="text-cyan-400 underline">
                                    ScubaReputation
                                </a> and
                                <a href="https://beunderwater.com" target="_blank" rel="noopener noreferrer" className="text-cyan-400 underline ml-1">
                                    BeUnderwater
                                </a> — and realized I was rebuilding the same stuff every time.
                            </p>
                            <p className="text-sm leading-relaxed">
                                So I created this <strong>Next.js boilerplate with two user roles (B2C & C2C)</strong>, ready to launch real apps fast.<br />
                                Perfect if you're building your next SaaS, marketplace, or idea you don’t want to overthink.
                            </p>
                        </div>
                    </div>

                    <div className="mb-12">
                        <div className="relative w-full max-w-3xl mx-auto aspect-[16/9]">
                            <iframe
                                className="w-full h-full rounded-lg"
                                src="https://www.youtube.com/embed/YBffgXbVVj8" // Replace VIDEO_ID with your actual YouTube video ID
                                title="Peerquik Demo Video"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        <p className="text-md mt-8 text-center text-gray-400 font-medium italic">
                            <span className="text-cyan-400 text-xl">"</span>Made for builders of real P2P products, not MVP demos<span className="text-cyan-400 text-xl">"</span>.
                        </p>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default Demo;